/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const _ = require("lodash");

const {ActivityMap, NewStatusActivityMap, RelNounMap} = require("../ActivityMaps");

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        _.set(
            activity,
            "description.description",
            `Plan created by user (${activityEntity.createdBy})`
        );
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeUpdateActivity(activityEntity) {
        let before = activityEntity.before;
        let patch = activityEntity.patch;
        if (_.isEmpty(patch)) {
            return;
        }
        let updatedBy =
            _.get(_.find(patch, {path: "/updatedBy"}), "value") ||
            _.get(before, "updatedBy") ||
            activityEntity.createdBy ||
            "system";
        let oldStatus = _.get(before, "status");
        let newStatus = _.get(_.find(patch, {path: "/status"}), "value");
        let activityValues =
            _.get(ActivityMap, [oldStatus, newStatus]) || NewStatusActivityMap[newStatus];
        if (activityValues) {
            let activity = {};
            _.set(activity, "activityType.activityType", activityValues.type);
            let description = activityValues.msg;
            if (activityValues.includeUser && updatedBy) {
                description += ` (${updatedBy})`;
            }
            _.set(activity, "description.description", description);
            let lastWorkId = activityEntity.getLastWorkId();
            if (lastWorkId) {
                //_.set(activity, "actions.viewMore", {logId: lastWorkId});
            }
            _.set(activity, "status", activityValues.status);
            return activity;
        } else {
            let activity = {};
            _.set(activity, "activityType.activityType", "note");
            _.set(activity, "description.description", `Plan updated by user (${updatedBy})`);
            _.set(activity, "status", "clean");
            return activity;
        }
    }

    _normalizeRelActivity(activityEntity) {
        let noun = RelNounMap[activityEntity.relName] || activityEntity.rEntityType;
        if (!noun) {
            return;
        }
        let action;
        if (activityEntity.activityType === "relDelete") {
            action = "removed from";
        } else if (activityEntity.activityType === "relAdd") {
            action = "added to";
        } else {
            return;
        }
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        let description = `${noun} ${action} the plan`;
        if (activityEntity.createdBy) {
            description += ` (${activityEntity.createdBy})`;
        }
        _.set(activity, "description.description", description);
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.activityType;
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
            case "relAdd":
            case "relDelete":
                activity = this._normalizeRelActivity(activityEntity);
                break;
        }
        if (!_.isEmpty(activity)) {
            let date =
                new Date(activityEntity.createdOn).toLocaleDateString() +
                " " +
                new Date(activityEntity.createdOn).toLocaleTimeString();

            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }

        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
